import { render } from "./SettingsDialog.vue?vue&type=template&id=6ab13f57&scoped=true"
import script from "./SettingsDialog.vue?vue&type=script&lang=js"
export * from "./SettingsDialog.vue?vue&type=script&lang=js"

import "./SettingsDialog.vue?vue&type=style&index=0&id=6ab13f57&scoped=true&lang=css"
import "./SettingsDialog.vue?vue&type=style&index=1&id=6ab13f57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab13f57"]])

export default __exports__